import React, { useState } from "react";
import { Box, Stack } from "@mui/material";

const AccessoryImageGallery = ({ images = [] }) => {
  const [selectedImage, setSelectedImage] = useState(images[0]);

  return (
    <Stack direction="row" spacing={1} alignItems="start">
      <Box sx={{ width: "100%", height: "100%" }}>
        <Box
          component="img"
          src={selectedImage}
          alt="main"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            borderRadius: 2,
          }}
        />
      </Box>

      <Stack spacing={1} sx={{ height: 200, overflow: "hidden" }}>
        <Box sx={{ width: "80px" }}>
          {images.map((img, idx) => (
            <Box
              key={idx}
              component="img"
              src={img}
              alt={`thumbnail-${idx}`}
              onClick={() => setSelectedImage(img)}
              sx={{
                width: 48,
                height: 48,
                borderRadius: 1,
                objectFit: "cover",
                cursor: "pointer",
                border:
                  selectedImage === img
                    ? "2px solid #FD7762"
                    : "1px solid #ccc",
              }}
            />
          ))}
        </Box>
      </Stack>
    </Stack>
  );
};

export default AccessoryImageGallery;
